import React, { useEffect, useState } from "react";
import TravelAuthorizationDisplayForm from "../../../forms/Claim/Travel/TravelAuthorizationDisplayForm";
import PropTypes from "prop-types";
import { getTravel } from "../../../../api/travelAuthorizationApi";
import { getSignedAttachmentUrl } from "../../../../api/attachApi";
import { toast } from "react-toastify";
import Axios from "axios";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const TravelAuthorizationDisplayPage = ({ history }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [travelDisplay, setTravelDisplay] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().year());
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(() => {
    setIsLoading(true);
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();
    getTravel(source, currentYear)
      .then((result) => {
        // reset pagination
        resetPagination();

        setTravelDisplay(result);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
    return () => {
      source.cancel();
    };
  }, [currentYear, t]);

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewTravel() {
    history("/home/travelauth/travelTrans");
  }

  function viewTravelTrans(TravelTransKey) {
    history("/home/travelauth/travelTrans/" + TravelTransKey);
  }

  function getValidAttachments(attachments) {
    return getSignedAttachmentUrl(attachments);
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <TravelAuthorizationDisplayForm
      isLoading={isLoading}
      data={travelDisplay}
      onAdd={onAddNewTravel}
      onView={viewTravelTrans}
      onAttachmentClicked={getValidAttachments}
      setCurrentYear={setCurrentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
};

TravelAuthorizationDisplayPage.propTypes = {
  history: PropTypes.func.isRequired,
};

export default TravelAuthorizationDisplayPage;
